<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-maintenance-log
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-maintenance-log
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateMaintenanceLog: () => import("./dialogs/CreateMaintenanceLog.vue"),
    EditMaintenanceLog: () => import("./dialogs/EditMaintenanceLog.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      permissions: {
        view: "vehicle-maintenance-logs.view",
        create: "vehicle-maintenance-logs.create",
        edit: "vehicle-maintenance-logs.edit",
        delete: "vehicle-maintenance-logs.delete",
      },
      //
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "maintenanceLogs/getLoading",
      meta: "maintenanceLogs/getMeta",
      list: "maintenanceLogs/getList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "vehicle_id",
        },
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "vehicle_variant_name",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
              {
                text: this.$t("manufacturer"),
                align: "left",
                sortable: false,
                value: "tenant_name",
              },
            ]
          : []),
        ...(this.authUser.user_nature !== "fleet"
          ? [
              {
                text: this.$t("alloted"),
                align: "left",
                sortable: false,
                value: "alloted",
              },
            ]
          : []),
        {
          text: this.$t("service_date"),
          align: "left",
          sortable: false,
          value: "service_date",
        },
        {
          text: this.$t("maintenance_service_name"),
          align: "left",
          sortable: false,
          value: "maintenance_service_name",
        },
        {
          text: this.$t("service_details"),
          align: "left",
          sortable: false,
          value: "service_details",
        },
        {
          text: this.$t("current_odometer_reading"),
          align: "left",
          sortable: false,
          value: "current_odometer_reading",
        },
        {
          text: this.$t("next_mileage_reading"),
          align: "left",
          sortable: false,
          value: "next_mileage_reading",
        },
        {
          text: this.$t("next_service_date"),
          align: "left",
          sortable: false,
          value: "next_service_date",
        },
        {
          text: this.$t("created_by"),
          align: "left",
          sortable: false,
          value: "created_by_name",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["single_vehicle", "customer"];
      // if (this.authUser.isAdmin) {
      // } else {
      //   return [];
      // }
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  beforeDestroy() {
    const params = {
      name: "vehicle_maintenance_logs",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  mounted() {
    this.$store.dispatch("maintenanceLogs/setLoadingValue", true);
    this.$store.dispatch("maintenanceLogs/maintenanceServices");
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("maintenanceLogs/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("maintenanceLogs/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
